import React from "react";
import useTranslation from "@hooks/use_translation";
import type { GhrTask } from "@/types/task";
import TaskCard from "./TaskCard";
import FormIcon from "@/sprout/icons/form";
import JobInfo from "./JobInfo";

interface TaskCardProps {
  statusText: string;
  task: GhrTask;
}

const CandidateSurvey: React.FC<TaskCardProps> = ({ statusText, task }) => {
  const { t } = useTranslation("tasks");

  return (
    <TaskCard
      icon={<FormIcon />}
      statusText={statusText}
      task={task}
      title={t("candidateSurvey.title")}
      body={<JobInfo task={task} />}
      actionHref={task.url}
      actionText={t("candidateSurvey.completeSurvey")}
      dismissable={true}
      theme={{
        colors: {
          background: "bg-white",
          border: "border-gray-700",
          iconBackground: "bg-gray-500",
        },
      }}
    />
  );
};

export default CandidateSurvey;
